import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import { useAuthStore } from './stores/authStore';
import LoginPage from './pages/login/LoginPage';
import DashboardPageWrapper from './pages/dashboard/DashboardPageWrapper';
import MedicinesPageWrapper from './pages/medicines/MedicinesPageWrapper';
import InventoryPageWrapper from './pages/inventory/InventoryPageWrapper';
import SuppliersPageWrapper from './pages/suppliers/SuppliersPageWrapper';
import CustomersPageWrapper from './pages/customers/CustomersPageWrapper';
import StockInPageWrapper from './pages/stock-in/StockInPageWrapper';
import StockOutPageWrapper from './pages/stock-out/StockOutPageWrapper';
import SalePageWrapper from './pages/pos/SalePageWrapper';
import SystemInfoPage from './pages/system/SystemInfoPage';
import DebtsPageWrapper from './pages/debts/DebtsPageWrraper';
import RevenueReportWrapper from './pages/reports/Revenue/RevenueReportWrapper';
import StockInOutReportWrapper from './pages/reports/StockReport/StockinOutReportWrapper';
import ProfitReportWrapper from './pages/reports/ProfitReport/ProfitReportWrapper';
import ExpensesPageWrapper from './pages/expenses/ExpensesPageWrapper';
import AppLayout from './components/common/AppLayout';
import './App.css';


const { Content } = Layout;

const App = React.memo(() => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <AppLayout>
      <Content style={{ padding: '0', height: '100%' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPageWrapper />} />
          <Route path="/medicines" element={<MedicinesPageWrapper />} />
          <Route path="/inventory" element={<InventoryPageWrapper />} />
          <Route path="/suppliers" element={<SuppliersPageWrapper />} />
          <Route path="/customers" element={<CustomersPageWrapper />} />
          <Route path="/stock-in" element={<StockInPageWrapper />} />
          <Route path="/stock-out" element={<StockOutPageWrapper />} />
          <Route path="/sale" element={<SalePageWrapper />} />
          <Route path="/reports/stock-in-out" element={<StockInOutReportWrapper />} />
          <Route path="/system" element={<SystemInfoPage />} />
          <Route path="/debts" element={<DebtsPageWrapper />} />
          <Route path="/reports/revenue" element={<RevenueReportWrapper />} />
          <Route path="/reports/profit" element={<ProfitReportWrapper />} />
          <Route path="/expenses" element={<ExpensesPageWrapper />} />
        </Routes>
      </Content>
    </AppLayout>
  );
});

App.displayName = 'App';

export default App; 